import { PlusOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { ButtonCommon, PopoverCommon } from 'src/common'
import { CollapseSingleCommon } from 'src/common/CollapseSingleCommon/CollapseSingleCommon'
import { Empty } from 'antd'
import ExampleItem from '../Examples/components/ExampleItem/ExampleItem'
import { FormAddExampleItem } from '../FormAddExampleItem/FormAddExampleItem'
import './ExampleContent.scss'

const ExampleContent = ({ moreExamples, isTermEmpty }) => {
	const hasExamples = Array.isArray(moreExamples) && moreExamples.length > 0

	return (
		<section className="u-definition-from-dictionary u-custom-scrollbar">
			{/* Single add control (same idea as “+ Add definition” on VI/EN — no duplicate inside the list). */}
			<div className="u-row-right example-content__toolbar">
				<PopoverCommon
					content={<FormAddExampleItem />}
					trigger="click"
				>
					<ButtonCommon
						icon={<PlusOutlined />}
						size="small"
						ghost
						type="primary"
						title="Examples here are not tied to a single English/Vietnamese sense; they apply to the headword."
					>
						Add example
					</ButtonCommon>
				</PopoverCommon>
			</div>
			{hasExamples && (
				<CollapseSingleCommon header="More examples">
					<div className="suggest-group">
						<ul className="list-group">
							{moreExamples.map(item => (
								<ExampleItem
									key={item.id}
									id={item.id}
									example={item.example}
									translation={item.translation}
									wordMeaningID={item.wordMeaningID}
									dictWordID={item.dictWordID}
								/>
							))}
						</ul>
					</div>
				</CollapseSingleCommon>
			)}

			{!hasExamples && (
				<Empty description={isTermEmpty ? 'Empty' : undefined} />
			)}
		</section>
	)
}
ExampleContent.propTypes = {
	moreExamples: PropTypes.array,
}
export default ExampleContent
